import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Parallax from '../Parallax';
import './Project.css';

export default class Project extends Component {

    state = {
        color: this.props.data.colors.text,
        backgroundColor: this.props.data.colors.background
    }

    render() {
        var { data, id } = this.props;
        return (
            <Fragment>
                {id !==0 ? <div style={{ backgroundColor: this.state.backgroundColor, height: "12.5px" }} /> : <div/>}
                <Parallax id = {id} image={data.image}>
                    <div className="project-info" style={{ color: this.state.color }}>
                    
                        <h3 className="project-info-item" style={{ backgroundColor: this.state.backgroundColor }}>{data.title}</h3>
                        <p className="project-info-item" style={{ backgroundColor: this.state.backgroundColor }}>{data.description}</p>
                        <div className="info-container">
                            <div className={data.collaborators.length === 0 ? "project-info-item" : "project-info-item half-info"} style={{ float: data.collaborators.length === 0 ? "none" : "left", backgroundColor: this.state.backgroundColor }}>
                                <h4>Technologies:</h4>
                                <ul>
                                    {data.technologies.map((e, i) => (
                                        <li key={i}>{e}</li>
                                    ))}
                                </ul>
                            </div>
                            {data.collaborators.length !== 0 ?
                                <div className="project-info-item half-info" style={{ float: "right", backgroundColor: this.state.backgroundColor }}>
                                    <h4>Collaborators:</h4>
                                    <ul>
                                        {data.collaborators.map((e, i) => (
                                            <li key={i}><a target="_blank" href={e.website}>{e.name}</a></li>
                                        ))}
                                    </ul>
                                </div>
                                :
                                <div />
                            }
                        </div>
                        <div className="info-container">
                            <div className="project-info-item half-info" style={{ float: "left", backgroundColor: this.state.backgroundColor }}>
                        { data.link.internal ? <Link to={data.link.internal}><p className="icon-link"><i className="fas fa-external-link-alt fa-lg" /> {data.link.text}</p></Link>
                        : <a target="_blank" href={data.link.address}><p className="icon-link"><i className="fas fa-external-link-alt fa-lg" /> {data.link.text}</p></a> }
                            </div>
                            <div className="project-info-item half-info" style={{ float: "right", backgroundColor: this.state.backgroundColor }}>
                                <a target="_blank" href={data.repo}><p className="icon-link"><i className="fab fa-github fa-lg" /> Github Repository</p></a>
                            </div>
                        </div>
                    </div>
                </Parallax>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Project/Project.js